import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import toolsData from './toolsData';
import { ToolCard } from './ToolCard';
import './Tools.css';

export const ToolsIndex = () => {
	const [tocCollapsed, setTocCollapsed] = useState(false);

	const handleTocClick = (e, slug) => {
		e.preventDefault();
		const el = document.getElementById(`tool-${slug}`);
		if (el) {
			el.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	};

	const collectionSchema = {
		'@context': 'https://schema.org',
		'@type': 'CollectionPage',
		name: 'Free Sports Betting Calculators & Tools',
		description: 'Free betting calculators: odds converter, EV calculator, devig tool, parlay calculator, arbitrage finder, Kelly criterion, and more.',
		url: 'https://www.thewagerwiz.com/tools',
		publisher: {
			'@type': 'Organization',
			name: 'WagerWiz',
			url: 'https://www.thewagerwiz.com',
		},
	};

	return (
		<div className="tools-container">
			<Helmet>
				<title>Free Sports Betting Calculators & Tools | WagerWiz</title>
				<meta name="description" content="Free betting calculators: odds converter, EV calculator, devig tool, parlay calculator, arbitrage finder, Kelly criterion, hedge calculator, and more." />
				<link rel="canonical" href="https://www.thewagerwiz.com/tools" />
				<meta property="og:title" content="Free Sports Betting Calculators & Tools | WagerWiz" />
				<meta property="og:description" content="Free betting calculators: odds converter, EV calculator, devig tool, parlay calculator, arbitrage finder, and more." />
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://www.thewagerwiz.com/tools" />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content="Free Sports Betting Calculators & Tools | WagerWiz" />
				<meta name="twitter:description" content="Free betting calculators: odds converter, EV calculator, devig tool, parlay calculator, arbitrage finder, and more." />
				<script type="application/ld+json">{JSON.stringify(collectionSchema)}</script>
			</Helmet>

			<div className="tools-header">
				<h1 className="tools-title">Betting Calculators & Tools</h1>
				<p className="tools-subtitle">
					Free calculators to sharpen your edge. Convert odds, calculate EV, size your bets, and find arbitrage opportunities.
				</p>
			</div>

			<div className="tools-body">
				<aside className="tools-toc-wrap">
					<nav className="tools-toc" aria-label="Contents">
						<div className="tools-toc-header">
							<span className="tools-toc-title">Contents</span>
							<button
								type="button"
								className="tools-toc-toggle"
								onClick={() => setTocCollapsed(v => !v)}
								aria-expanded={!tocCollapsed}
							>
								[{tocCollapsed ? 'show' : 'hide'}]
							</button>
						</div>
						{!tocCollapsed && (
							<ol className="tools-toc-list">
								{toolsData.map((tool, idx) => (
									<li key={tool.slug}>
										<span className="tools-toc-num">{idx + 1}</span>
										<a
											href={`#tool-${tool.slug}`}
											className="tools-toc-link"
											onClick={(e) => handleTocClick(e, tool.slug)}
										>
											{tool.title}
										</a>
									</li>
								))}
							</ol>
						)}
					</nav>
				</aside>

				<div className="tools-grid">
					{toolsData.map(tool => (
						<ToolCard key={tool.slug} tool={tool} />
					))}
				</div>
			</div>
		</div>
	);
};
